import { Card } from '@/components/Card'
import styles from './JobWidget.module.css'
import type { ReactNode } from 'react'

export interface JobWidgetProps {
  header: ReactNode
  step?: ReactNode
  bookedTime?: ReactNode
  button: ReactNode
  children: ReactNode
}

export function JobWidget({
  header,
  children,
  bookedTime,
  button,
}: JobWidgetProps) {
  return (
    <div className={styles.root}>
      {header}

      <Card>
        {bookedTime && (
          <div className={styles.consultationBookedTime}>{bookedTime}</div>
        )}

        <div className={styles.content}>{children}</div>
      </Card>

      {button}
    </div>
  )
}
